import { IDuplicateDebtors } from "us.collection.debtor/Interfaces";

export const initialState: IDuplicateDebtors = {
  duplicatingDebtors: {
    isLoading: false,
    data: [],
  },
  selectedDebtors: [],
  debtorHistory: {
    isLoading: false,
    data: [],
  },
  isDebtorMergeSaving: false,
};
